import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'ck-ui';
import { useSash } from './hooks/useSash';
import styles from './ProductBottomSash.module.scss';

const ProductBottomSash = ({ tags }) => {
  const sash = useSash(tags);

  const { bottomSash } = sash;

  if (!bottomSash || !bottomSash.label) return null;

  const { label, color } = bottomSash;

  return (
    <Typography
      display="block"
      className={styles.bottomSash}
      color={color || 'success-dark'}
      align="centered"
      capitalize
    >
      {label}
    </Typography>
  );
};

ProductBottomSash.propTypes = {
  tags: PropTypes.array.isRequired
};

export { ProductBottomSash };
